import React from 'react';
import PropTypes from 'prop-types';
import {filter, map} from 'lodash';
import CollapsibleSection from 'src/components/collapsible-section';
import ConnectionInformationCard from './connection-information-card';
import Title from 'src/components/AccountSettings/Title';

const propTypes = {
  educatorConnections: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,
      connection: PropTypes.number.isRequired,
      createdAt: PropTypes.string.isRequired,
      educator: PropTypes.shape({
        displayNameToStudent: PropTypes.string.isRequired,
      }).isRequired,
    })
  ).isRequired,
  userConnections: PropTypes.arrayOf(
    PropTypes.shape({
      status: PropTypes.string.isRequired,
      createdAt: PropTypes.string.isRequired,
      connectedUser: PropTypes.shape({
        firstName: PropTypes.string.isRequired,
        lastName: PropTypes.string.isRequired,
      }).isRequired,
      _id: PropTypes.string.isRequired,
    })
  ).isRequired,
  acceptEducatorConnection: PropTypes.func.isRequired,
  rejectEducatorConnection: PropTypes.func.isRequired,
  acceptConnection: PropTypes.func.isRequired,
  rejectConnection: PropTypes.func.isRequired,
  removeConnection: PropTypes.func.isRequired,
};

const RejectedConnectionsList = ({
  educatorConnections,
  userConnections,
  acceptEducatorConnection,
  rejectEducatorConnection,
  acceptConnection,
  rejectConnection,
  removeConnection,
}) => {
  const rejectedUserConnections = filter(userConnections, ({status}) => status === 'rejected');
  const rejectedEducatorConnections = filter(
    educatorConnections,
    ({connection}) => connection === -1
  );

  const hasRejected = rejectedUserConnections.length > 0 || rejectedEducatorConnections.length > 0;

  if (!hasRejected) return null;

  return (
    <div
      className="account-settings-form mt-24"
      id="connections-container"
      data-testid="rejected-connections-list"
    >
      <Title>Rejected Connections</Title>
      <p className="shared-text shared-text-show-overflow high-school-student-connections-page-text pb-0">
        You can view your rejected connections in this section
      </p>
      <CollapsibleSection className="rejected-connections-section" isOpen={false}>
        <div className="connections-list row">
          {map(rejectedUserConnections, ({connectedUser: {firstName, lastName, image}, _id}) => (
            <ConnectionInformationCard
              id={_id}
              status="rejected"
              firstName={firstName}
              lastName={lastName}
              image={image}
              displayName={`${firstName} ${lastName}`}
              key={_id}
              acceptConnection={acceptConnection}
              rejectConnection={rejectConnection}
              removeConnection={removeConnection}
              type="Parent"
            />
          ))}
          {map(
            rejectedEducatorConnections,
            ({_id, educator: {displayNameToStudent, firstName, lastName}}) => (
              <ConnectionInformationCard
                id={_id}
                status="rejected"
                firstName={firstName}
                lastName={lastName}
                displayName={displayNameToStudent}
                key={_id}
                acceptConnection={acceptEducatorConnection}
                rejectConnection={rejectEducatorConnection}
                removeConnection={rejectEducatorConnection}
                type="Educator"
              />
            )
          )}
        </div>
      </CollapsibleSection>
    </div>
  );
};

RejectedConnectionsList.propTypes = propTypes;

export default RejectedConnectionsList;
